import React, { useState, useEffect } from "react";
import "../../components/DashboardModule/BuyerQuotationDashboard.css";
import { compareBuyerPreviewEnquiries, updateEnquiryQuotationStatus } from "../../API/Api";
import { getAuthToken, getBankDetails, getUserDetails } from "../../utils/auth";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { toWords } from 'number-to-words';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { FaRegFilePdf } from "react-icons/fa6";
import { FaRegFileExcel } from "react-icons/fa6";
import electripLogo from "../../assets/images/electriplogo.png";
import stelmartLogo from "../../assets/images/stelmartlogo.png";

const BuyerQuotationDashboard = ({ enquiryId }) => {
	const [activeTab, setActiveTab] = useState("summary");
	const [enquiryData, setEnquiryData] = useState(null);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);
	const [token, setToken] = useState(null);
	const [selectedQuote, setSelectedQuote] = useState(null);
	const [isUpdatingStatus, setIsUpdatingStatus] = useState(false);
	const [bankDetails, setBankDetails] = useState(null);
	const [expandedVendor, setExpandedVendor] = useState(null);

	console.log("NIVI:::----", enquiryData)
	useEffect(() => {
		const details = getUserDetails();
		console.log("Fetched bank details:", details);
		setBankDetails(details);
	}, []);

	useEffect(() => {
		setToken(getAuthToken());
	}, []);

	useEffect(() => {
		const fetchComparisonData = async () => {
			try {
				setLoading(true);
				const response = await compareBuyerPreviewEnquiries(enquiryId);
				console.log("VenderID::-", response)
				if (response.status === false) {
					setError(response.message || "Failed to load comparison data");
					return;
				}
				setEnquiryData(response.data);
			} catch (err) {
				setError(err.message || "Failed to load comparison data");
			} finally {
				setLoading(false);
			}
		};

		if (enquiryId) {
			fetchComparisonData();
		}
	}, [enquiryId]);

	const handleDownloadClick = () => {
		const choice = window.prompt("Download as 'excel' or 'pdf'?");
		if (choice === "excel") {
			downloadExcel();
		} else if (choice === "pdf") {
			downloadPDF();
		} else {
			alert("Invalid choice. Please enter 'excel' or 'pdf'.");
		}
	};


	const downloadExcel = () => {
		try {
			const wb = XLSX.utils.book_new();
			const wsData = [];

			const header = [
				"Size", "Thickness", "Ends", "Finish", "Quantity", "Unit",
				...quotations.flatMap(q => [`${q.vendor_name} Rate`, "Value"])
			];
			wsData.push(header);

			const rowCount = quotations[0]?.items?.length || 0;
			for (let i = 0; i < rowCount; i++) {
				const baseItem = quotations[0].items[i];
				const row = [
					baseItem.size,
					baseItem.wall_thickness,
					baseItem.end,
					baseItem.finish,
					baseItem.universal_qty,
					baseItem.quantity_unit,
					...quotations.flatMap(q => {
						const item = q.items[i] || {};
						const rate = Number(item.unit_price || 0).toFixed(2);
						const value = (Number(item.unit_price || 0) * Number(item.universal_qty || 0)).toFixed(2);
						return [rate, value];
					})
				];
				wsData.push(row);
			}

			const addRow = (label, getValue) => {
				const row = ["", "", "", "", "", label];
				quotations.forEach(q => {
					row.push(getValue(q), "");
				});
				wsData.push(row);
			};

			addRow("Basic Value", (q) =>
				q.items.reduce((sum, item) =>
					sum + (Number(item.unit_price || 0) * Number(item.universal_qty || 0)), 0
				).toFixed(2)
			);

			addRow("Other Charges", (q) =>
				Number(q.other_charges || 0).toFixed(2)
			);

			addRow("Total Taxable", (q) => {
				const base = q.items.reduce((sum, item) =>
					sum + (Number(item.unit_price || 0) * Number(item.universal_qty || 0)), 0
				);
				return (base + Number(q.other_charges || 0)).toFixed(2);
			});

			addRow("GST ", (q) => {
				const base = q.items.reduce((sum, item) =>
					sum + (Number(item.unit_price || 0) * Number(item.universal_qty || 0)), 0
				);
				const tax = base + Number(q.other_charges || 0);
				const gst = (tax * (Number(q.gst_percentage || 0) / 100));
				return `${Number(q.gst_percentage).toFixed(2)}% (${gst.toFixed(2)})`;
			});

			addRow("Grand Total", (q) => {
				const base = q.items.reduce((sum, item) =>
					sum + (Number(item.unit_price || 0) * Number(item.universal_qty || 0)), 0
				);
				const tax = base + Number(q.other_charges || 0);
				const gst = (tax * (Number(q.gst_percentage || 0) / 100));
				return (tax + gst).toFixed(2);
			});

			const ws = XLSX.utils.aoa_to_sheet(wsData);
			XLSX.utils.book_append_sheet(wb, ws, "Quotation");

			XLSX.writeFile(wb, `enquiry_${enquiry_info.number}_offers.xlsx`);

			toast.success("Excel file downloaded successfully!");
		} catch (err) {
			console.error("Excel download error:", err);
			toast.error("Failed to download Excel file.");
		}
	};

	// const downloadPDF = () => {
	// 	try {
	// 		const doc = new jsPDF();
	// 		doc.setFontSize(16);
	// 		doc.text(`Enquiry #${enquiry_info.number} - ${enquiry_info.title}`, 14, 15);
	// 		doc.setFontSize(12);
	// 		doc.text("Quotation Comparison", 14, 25);

	// 		const head = [[
	// 			"Size", "Thickness", "Ends", "Finish", "Quantity", "Unit",
	// 			...quotations.flatMap(q => [`${q.vendor_name} Rate`, "Value"])
	// 		]];

	// 		const body = [];
	// 		const rowCount = quotations[0]?.items?.length || 0;
	// 		for (let i = 0; i < rowCount; i++) {
	// 			const row = [
	// 				quotations[0].items[i].size,
	// 				quotations[0].items[i].wall_thickness,
	// 				quotations[0].items[i].end,
	// 				quotations[0].items[i].finish,
	// 				quotations[0].items[i].universal_qty,
	// 				quotations[0].items[i].quantity_unit,
	// 				...quotations.flatMap(q => {
	// 					const item = q.items[i] || {};
	// 					const rate = Number(item.unit_price || 0).toFixed(2);
	// 					const value = (Number(item.unit_price || 0) * Number(item.universal_qty || 0)).toFixed(2);
	// 					return [rate, value];
	// 				})
	// 			];
	// 			body.push(row);
	// 		}

	// 		const addRow = (label, getValue) => {
	// 			const row = ["", "", "", "", "", label];
	// 			quotations.forEach(q => {
	// 				row.push(getValue(q), "");
	// 			});
	// 			body.push(row);
	// 		};

	// 		addRow("Basic Value", (q) =>
	// 			q.items.reduce((sum, item) =>
	// 				sum + (Number(item.unit_price || 0) * Number(item.universal_qty || 0)), 0
	// 			).toFixed(2)
	// 		);

	// 		addRow("Other Charges", (q) =>
	// 			Number(q.other_charges || 0).toFixed(2)
	// 		);

	// 		addRow("Total Taxable", (q) => {
	// 			const base = q.items.reduce((sum, item) =>
	// 				sum + (Number(item.unit_price || 0) * Number(item.universal_qty || 0)), 0
	// 			);
	// 			return (base + Number(q.other_charges || 0)).toFixed(2);
	// 		});

	// 		addRow("GST", (q) => {
	// 			const base = q.items.reduce((sum, item) =>
	// 				sum + (Number(item.unit_price || 0) * Number(item.universal_qty || 0)), 0
	// 			);
	// 			const tax = base + Number(q.other_charges || 0);
	// 			const gst = (tax * (Number(q.gst_percentage || 0) / 100));
	// 			return `${Number(q.gst_percentage).toFixed(2)}% (${gst.toFixed(2)})`;
	// 		});

	// 		addRow("Grand Total", (q) => {
	// 			const base = q.items.reduce((sum, item) =>
	// 				sum + (Number(item.unit_price || 0) * Number(item.universal_qty || 0)), 0
	// 			);
	// 			const tax = base + Number(q.other_charges || 0);
	// 			const gst = (tax * (Number(q.gst_percentage || 0) / 100));
	// 			return (tax + gst).toFixed(2);
	// 		});

	// 		autoTable(doc, {
	// 			startY: 30,
	// 			head: head,
	// 			body: body,
	// 			styles: { fontSize: 8 },
	// 			headStyles: { fillColor: [22, 160, 133] }
	// 		});

	// 		doc.save(`enquiry_${enquiry_info.number}_offers.pdf`);
	// 		toast.success("PDF file downloaded successfully!");
	// 	} catch (err) {
	// 		console.error("PDF download error:", err);
	// 		toast.error("Failed to generate PDF file.");
	// 	}
	// };


	const downloadPDF = () => {
		const img1 = new Image();
		img1.src = electripLogo;

		const img2 = new Image();
		img2.src = stelmartLogo;

		img1.onload = () => {
			img2.onload = () => {
				try {
					const doc = new jsPDF({
						orientation: "landscape",
						unit: "mm",
						format: "a4"
					});

					const logoWidth = 30;
					const logoHeight = 20;
					const verticalPosition = 10;
					const pageWidth = doc.internal.pageSize.getWidth();
					const totalSpace = pageWidth - (2 * logoWidth);
					const spacing = totalSpace / 3;

					// Left logo
					doc.addImage(img1, "PNG", spacing, verticalPosition, logoWidth, logoHeight);

					// Centered company name
					doc.setFontSize(14);
					doc.setTextColor(0, 0, 0);
					doc.setFont("helvetica", "bold");
					const textY = verticalPosition + (logoHeight / 2) + 4;
					doc.text("ELECTRIP PRIVATE LIMITED", pageWidth / 2, textY, { align: 'center' });

					// Right logo
					doc.addImage(img2, "PNG", spacing + logoWidth + spacing, verticalPosition, logoWidth, logoHeight);

					// Company address and contact info
					doc.setFontSize(10);
					doc.setTextColor(0, 0, 0);
					doc.setFont("helvetica", "bold");
					let currentY = verticalPosition + logoHeight + 4;
					doc.text("H-58, GROUND FLOOR, SOUTH CITY-II, SECTOR-50, GURUGRAM, HARYANA-122018", pageWidth / 2, currentY, { align: 'center' });
					currentY += 5;
					doc.setFont("helvetica", "normal");
					doc.text("Contact detail: Mob.No.9350102291, Email: rahul@electrip.co.in", pageWidth / 2, currentY, { align: 'center' });

					// Divider line
					currentY += 5;
					doc.setDrawColor(200, 200, 200);
					doc.line(15, currentY, pageWidth - 15, currentY);

					if (!quotations || !Array.isArray(quotations) || quotations.length === 0) {
						throw new Error("No quotation data available");
					}

					const head = [
						[
							{ content: "Item Details", colSpan: 6, styles: { halign: 'center', fillColor: [40, 53, 147], textColor: 255 } },
							...quotations.map(q => ({
								content: q.vendor_name,
								colSpan: 2,
								styles: { halign: 'center', fillColor: [40, 53, 147], textColor: 255 }
							}))
						],
						[
							"Size", "Thickness", "Ends", "Finish", "Quantity", "Unit",
							...quotations.flatMap(() => ["Rate", "Value"])
						]
					];

					const body = [];
					const rowCount = quotations[0]?.items?.length || 0;

					for (let i = 0; i < rowCount; i++) {
						const row = [
							quotations[0].items[i].size || '-',
							quotations[0].items[i].wall_thickness || '-',
							quotations[0].items[i].end || '-',
							quotations[0].items[i].finish || '-',
							quotations[0].items[i].universal_qty || '-',
							quotations[0].items[i].quantity_unit || '-',
							...quotations.flatMap(q => {
								const item = q.items[i] || {};
								const rate = item.unit_price ? Number(item.unit_price).toFixed(2) : '-';
								const value = (item.unit_price && item.universal_qty)
									? (Number(item.unit_price) * Number(item.universal_qty)).toFixed(2)
									: '-';
								return [rate, value];
							})
						];
						body.push(row);
					}

					const summaryLabels = [];

					const addSummaryRow = (label, getValue) => {
						const row = ["", "", "", "", "", label];
						quotations.forEach(q => {
							const value = getValue(q);
							row.push(value, "");
						});
						body.push(row);
						summaryLabels.push(label);
					};

					addSummaryRow("Basic Value", (q) =>
						q.items.reduce((sum, item) =>
							sum + (Number(item.unit_price || 0) * Number(item.universal_qty || 0)), 0
						).toFixed(2)
					);

					addSummaryRow("Other Charges", (q) =>
						Number(q.other_charges || 0).toFixed(2)
					);

					addSummaryRow("Total Taxable", (q) => {
						const base = q.items.reduce((sum, item) =>
							sum + (Number(item.unit_price || 0) * Number(item.universal_qty || 0)), 0
						);
						return (base + Number(q.other_charges || 0)).toFixed(2);
					});

					addSummaryRow("GST (18.00%)", (q) => {
						const base = q.items.reduce((sum, item) =>
							sum + (Number(item.unit_price || 0) * Number(item.universal_qty || 0)), 0
						);
						const tax = base + Number(q.other_charges || 0);
						const gst = tax * (Number(q.gst_percentage || 0) / 100);
						return `${gst.toFixed(2)}`;
						// return `${Number(q.gst_percentage || 0).toFixed(2)}% (${gst.toFixed(2)})`;
					});

					body.push([
						{
							content: "Grand Total",
							colSpan: 6,
							styles: {
								fontStyle: 'bold',
								fontSize: 10,
								textColor: 0,
								halign: 'center',
								lineWidth: 0.2,
								lineColor: [0, 0, 0]
							}
						},
						...quotations.flatMap(q => {
							const base = q.items.reduce((sum, item) =>
								sum + (Number(item.unit_price || 0) * Number(item.universal_qty || 0)), 0
							);
							const tax = base + Number(q.other_charges || 0);
							const gst = tax * (Number(q.gst_percentage || 0) / 100);
							const total = tax + gst;
							return [
								{
									content: total.toFixed(2),
									styles: {
										fontStyle: 'bold',
										fontSize: 10,
										textColor: 0,
										lineWidth: 0.2,
										lineColor: [0, 0, 0]
									}
								},
								{
									content: "",
									styles: {
										lineWidth: 0.2,
										lineColor: [0, 0, 0]
									}
								}
							];
						})
					]);



					// Table
					autoTable(doc, {
						startY: currentY + 5,
						head: head,
						body: body,
						styles: {
							fontSize: 8,
							cellPadding: 2,
							halign: 'center',
							fontStyle: 'bold',
							lineColor: [200, 200, 200], // Light gray line color
							lineWidth: 0.1              // Thin border lines
						},
						headStyles: {
							fillColor: [255, 255, 255],   // White background
							textColor: [0, 0, 0],         // Black text
							fontStyle: 'bold',
							lineColor: [0, 0, 0],
							lineWidth: 0.1
						},

						alternateRowStyles: {
							fillColor: [240, 240, 240]
						},
						margin: { left: 15 },
						didDrawCell: function (data) {
							try {
								const labelCellIndex = 5;
								const cellValue = data.row.raw?.[labelCellIndex];
								if (summaryLabels.includes(cellValue)) {
									const pageWidth = doc.internal.pageSize.getWidth();
									const y = data.cell.y + data.cell.height;
									doc.setDrawColor(180); // Light gray
									doc.setLineWidth(0.1); // Very thin line
									doc.line(15, y, pageWidth - 15, y);
								}
							} catch (e) {
								console.warn("Skipped drawing line due to error:", e.message);
							}
						},
						didDrawPage: function (data) {
							doc.setFontSize(10);
							doc.setTextColor(100);
							doc.text(
								`Page ${data.pageCount}`,
								doc.internal.pageSize.getWidth() / 2,
								doc.internal.pageSize.getHeight() - 10,
								{ align: 'center' }
							);
						}
					});

					// Vendor notes
					doc.setFontSize(10);
					doc.setTextColor(0, 0, 0);

					quotations.forEach((q, i) => {
						const yPos = doc.lastAutoTable.finalY + 15 + (i * 15);
						doc.setFont("helvetica", "bold");
						doc.text(`${q.vendor_name}`, 15, yPos);
						doc.setFont("helvetica", "normal");
						doc.text(q.notes || "", 40, yPos);
					});

					const fileName = enquiry_info?.number
						? `Stelmart_Quotation_Comparison_${enquiry_info.number}.pdf`
						: `Stelmart_Quotation_Comparison_${new Date().toISOString().slice(0, 10)}.pdf`;

					doc.save(fileName);

					toast.success("PDF report generated successfully!", {
						position: "top-right",
						autoClose: 3000
					});
				} catch (err) {
					console.error("PDF generation error:", err);
					toast.error("Failed to generate PDF: " + err.message, {
						position: "top-right",
						autoClose: 5000
					});
				}
			};
		};
	};

	const handleTabChange = (tabId) => {
		setActiveTab(tabId);
	};

	if (loading) {
		return <div>Loading...</div>;
	}
	if (error) {
		return <div className="error-message">Error: {error}</div>;
	}

	if (!enquiryData) {
		return <div>No data available for this enquiry.</div>;
	}

	const convertToWords = (amount) => {
		try {
			const rupees = Math.floor(amount);
			const paise = Math.round((amount - rupees) * 100);
			let words = toWords(rupees) + ' rupees';
			if (paise > 0) {
				words += ' and ' + toWords(paise) + ' paise';
			}
			return words;
		} catch (error) {
			console.error("Error converting number to words:", error);
			return "Amount in words unavailable";
		}
	};


	const capitalizeFirstLetter = (str) => {
		if (!str) return str;
		return str.charAt(0).toUpperCase() + str.slice(1);
	};



	const { enquiry_info, summary, quotations, parameters } = enquiryData;

	const renderVendorPrices = (paramName, unit) => {
		return quotations.map((quote, index) => {
			const item = quote.items.find(item =>
				item.name.includes(paramName.split('(')[0].trim()) &&
				item.unit === unit
			);
			return (
				<td key={index}>
					{item ? `${item.unit_price}/${item.unit}` : '....'}
				</td>
			);
		});
	};


	const handleSelectOffer = async (vendorName, vendorId) => {
		console.log("Vendor ID:", vendorId);
		try {
			setIsUpdatingStatus(true);

			const statusData = {
				enquiry_id: enquiryId,
				seller_id: vendorId,
				status: 'Success',
				token: token
			};
			console.log("statusData", statusData);

			const response = await updateEnquiryQuotationStatus(statusData);

			if (response.success) {
				toast.success(`You have selected ${vendorName}. Status updated successfully!`, {
					position: "top-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
				});
				const updatedResponse = await compareBuyerPreviewEnquiries(enquiryId);
				if (updatedResponse.status !== false) {
					setEnquiryData(updatedResponse.data);
				}
			} else {
				toast.error(`Failed to update status: ${response.message}`, {
					position: "top-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
				});
			}
		} catch (error) {
			toast.error(` ${error.message || 'Unknown error'}`, {
				position: "top-right",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
			});
			console.error("Error details:", error);
		} finally {
			setIsUpdatingStatus(false);
		}
	};
	return (
		<div className="container Buyer-Quotation-Dashboard">
			<ToastContainer
				position="top-right"
				autoClose={5000}
				hideProgressBar={false}
				newestOnTop={false}
				closeOnClick
				rtl={false}
				pauseOnFocusLoss
				draggable
				pauseOnHover
			/>
			<div className="stelmart-banner Buyer-Quotation-Dashboard">
				<div className="banner-left Buyer-Quotation-Dashboard">
					<div className="banner-title Buyer-Quotation-Dashboard">
						<h1>Buyer Quotation Dashboard</h1>
						<span>Enquiry #{enquiry_info.number} - {enquiry_info.title}</span>
					</div>
				</div>
				<div className="status-badge">{summary.total_quotations} Offers Available</div>
			</div>

			<div className="dashboard-container">
				<div className="tab-nav">
					<div
						className={`tab-btn ${activeTab === "summary" ? "active" : ""}`}
						onClick={() => handleTabChange("summary")}
					>
						Quote Summary
					</div>
					{/* <div
						className={`tab-btn ${activeTab === "comparison" ? "active" : ""}`}
						onClick={() => handleTabChange("comparison")}
					>
						Offer Comparison
						<span className="tab-badge">{summary.total_quotations}</span>
					</div> */}
					<div
						className={`tab-btn ${activeTab === "details" ? "active" : ""}`}
						onClick={() => handleTabChange("details")}
					>
						Offer Comparison
						<span className="tab-badge">{summary.total_quotations}</span>

					</div>
					<div
						className={`tab-btn ${activeTab === "market" ? "active" : ""}`}
						onClick={() => handleTabChange("market")}
					>
						Market Analysis
					</div>
				</div>


				{/* Summary Tab */}
				<div className={`tab-content ${activeTab === "summary" ? "active" : ""}`} id="summary">
					<h2 className="quotation-text-buyer">Quotation Summary</h2>
					<p className="quotation-text-buyer">This section provides an overview of the entire quotation along with key statistics.</p>
					<div className="stats-grid">
						<div className="stat-card quotation-text-buyer">
							<div className="stat-value">{summary.total_quotations}</div>
							<div className="stat-label">Offers Available</div>
						</div>
						<div className="stat-card quotation-text-buyer">
							<div className="stat-value">₹{summary.price_range.min?.toFixed(2)} - ₹{summary.price_range.max?.toFixed(2)}</div>
							<div className="stat-label">Price Range</div>
						</div>
						<div className="stat-card quotation-text-buyer">
							<div className="stat-value">{summary.delivery_range}</div>
							<div className="stat-label">Delivery Range</div>
						</div>
						<div className="stat-card quotation-text-buyer">
							<div className="stat-value">₹{summary.price_range.avg.toFixed(2)}</div>
							<div className="stat-label">Average Price</div>
						</div>
					</div>

					<div className="summary-container">
						<table className="summary-table">
							<thead>
								<tr>
									<th className="param-col">Parameter</th>
									{quotations.map((quote, index) => (
										<th key={index}>{quote.vendor_name}</th>
									))}
									{/* <th className="param-col">Buyer Requirement</th> */}
								</tr>
							</thead>
							<tbody>
								{parameters.map((param, idx) => (
									<tr key={idx}>
										<td className="param-col">{param.item_name} ({param.unit})</td>
										{renderVendorPrices(param.item_name, param.unit)}
										{/* <td className="param-col">{param.market_range}</td> */}
									</tr>
								))}
								<tr>
									<td className="param-col">Subtotal</td>
									{quotations.map((quote, index) => (
										<td key={index}>₹{quote.subtotal?.toFixed(2)}</td>
									))}
									{/* <td className="param-col">-</td> */}
								</tr>
								<tr>
									<td className="param-col">Other Charges</td>
									{quotations.map((quote, index) => (
										<td key={index}>₹{quote.other_charges}</td>
									))}
									{/* <td className="param-col">-</td> */}
								</tr>
								<tr>
									<td className="param-col">GST ({quotations[0]?.gst_percentage}%)</td>
									{quotations.map((quote, index) => (
										<td key={index}>₹{quote.gst_amount.toFixed(2)}</td>
									))}
									{/* <td className="param-col">-</td> */}
								</tr>
								<tr>
									<td className="param-col">Total Price</td>
									{quotations.map((quote, index) => (
										<td key={index}>₹{quote.total_price.toFixed(2)}</td>
									))}
									{/* <td className="param-col">
										{summary.budget_comparison.budget > 0 ?
											`Budget: ₹${summary.budget_comparison.budget}` : '-'}
									</td> */}
								</tr>
								<tr>
									<td className="param-col">Total Price in Words</td>
									{quotations.map((quote, index) => (
										<td key={index}>
											<br />
											{capitalizeFirstLetter(convertToWords(quote.total_price))}
										</td>
									))}
									{/* <td className="param-col">
										{summary.budget_comparison.budget > 0 ?
											`Budget: ₹${summary.budget_comparison.budget}` : ''}
									</td> */}
								</tr>
								<tr>
									<td className="param-col">Payment Terms</td>
									{quotations.map((quote, index) => (
										<td key={`payment-${index}`}>
											<div>
												<strong>Terms:</strong> {quote.seller_payment_terms}
											</div>
											<div>
												<strong>Payment Term Days:</strong> {quote.seller_payment_term_number_days || 'N/A'}
											</div>
											{quote.seller_payment_terms && quote.seller_payment_terms.toLowerCase().includes('advance') && (
												<>
													<div>
														<strong>Advance Type:</strong> {quote.seller_advance_type || 'N/A'}
													</div>
													<div>
														<strong>Advance Value:</strong> {quote.seller_advance_payment_value || 'N/A'}
													</div>
													<div>
														<strong>Rest Payment Days:</strong> {quote.seller_rest_paid_within_days || 'N/A'}
													</div>
												</>
											)}
										</td>
									))}
								</tr>
								<tr>
									<td className="param-col">Material Test Certificate(MTC)</td>
									{quotations.map((quote, index) => (
										<td key={`notes-${index}`}>
											{quote.notes ? (
												<p>{quote.notes}</p>
											) : (
												<span>-</span>
											)}
										</td>
									))}
								</tr>
								<tr>
									<td className="param-col">Vendor Notes</td>
									{quotations.map((quote, index) => (
										<td key={`notes-${index}`} >
											{quote.notes ? (
												<p>{quote.notes}</p>
											) : (
												<em>No notes</em>
											)}
										</td>
									))}
								</tr>
								<tr>
									<td className="param-col">Terms & Conditions</td>
									{quotations.map((quote, index) => (
										<td key={`terms-${index}`}>
											{quote.term_conditions ? (
												<p>{quote.term_conditions}</p>
											) : (
												<em>No terms specified</em>
											)}
										</td>
									))}
								</tr>


							</tbody>

						</table>

					</div>

					{/* <div className="action-bar">
            <button className="btn btn-primary" onClick={() => handleSelectOffer()}>Select Offer</button>
          </div> */}
				</div>
				<div className={`tab-content ${activeTab === "comparison" ? "active" : ""}`} id="comparison">
					<h2>Offer Comparison</h2>
					<p>Compare key aspects of all offers side by side.</p>
					<div className="summary-container">
						<table className="summary-table">
							<thead>
								<tr>
									<th className="param-col">Parameter</th>
									{quotations.map((quote, index) => (
										<th key={index}>{quote.vendor_name}</th>
									))}
									{/* <th className="param-col">Buyer Requirement</th> */}
								</tr>
							</thead>
							<tbody>
								{parameters.map((param, idx) => {
									const prices = quotations.map(quote => {
										const item = quote.items.find(item =>
											item.name.includes(param.item_name.split('(')[0].trim()) &&
											item.unit === param.unit
										);
										return item ? parseFloat(item.unit_price) : Infinity;
									});
									const minPrice = Math.min(...prices);

									return (
										<tr key={idx}>
											<td className="param-col">{param.item_name} ({param.unit})</td>
											{quotations.map((quote, index) => {
												const item = quote.items.find(item =>
													item.name.includes(param.item_name.split('(')[0].trim()) &&
													item.unit === param.unit
												);
												const price = item ? parseFloat(item.unit_price) : null;
												const isBestValue = price === minPrice;

												return (
													<td key={index} className={isBestValue ? "best-value" : ""}>
														{item ? `${item.unit_price}/${item.unit}` : '....'}
													</td>
												);
											})}
											<td className="param-col">{param.market_range}</td>
										</tr>
									);
								})}
								<tr>
									<td className="param-col">Subtotal</td>
									{quotations.map((quote, index) => (
										<td key={index}>₹{quote.subtotal}</td>
									))}
									<td className="param-col">-</td>
								</tr>
								<tr>
									<td className="param-col">Other Charges</td>
									{quotations.map((quote, index) => (
										<td key={index}>₹{quote.other_charges}</td>
									))}
									<td className="param-col">-</td>
								</tr>
								<tr>
									<td className="param-col">GST ({quotations[0]?.gst_percentage}%)</td>
									{quotations.map((quote, index) => (
										<td key={index}>₹{quote.gst_amount.toFixed(2)}</td>
									))}
									<td className="param-col">-</td>
								</tr>
								<tr>
									<td className="param-col">Total Price</td>
									{quotations.map((quote, index) => (
										<td key={index}>₹{quote.total_price.toFixed(2)}</td>
									))}
									<td className="param-col">
										{summary.budget_comparison.budget > 0 ?
											`Budget: ₹${summary.budget_comparison.budget}` : '-'}
									</td>
								</tr>
								<tr>
									<td className="param-col">Total Price in Words</td>
									{quotations.map((quote, index) => (
										<td key={index}>
											<br />
											{capitalizeFirstLetter(convertToWords(quote.total_price))}
										</td>
									))}
									<td className="param-col">
										{summary.budget_comparison.budget > 0 ?
											`Budget: ₹${summary.budget_comparison.budget}` : '-'}
									</td>

								</tr>

							</tbody>
						</table>

					</div>

				</div>


				<div className={`tab-content ${activeTab === "details" ? "active" : ""}`} id="details">
					<div className="quotation-details-header">
						<h2>Detailed Offers</h2>

						<div className="download-options">

							<button className="btn btn-secondary-pdf" onClick={downloadExcel}>
								<FaRegFileExcel />  Download Excel
							</button>
							<button className="btn btn-secondary-pdf" onClick={downloadPDF}>
								<FaRegFilePdf />  Download PDF
							</button>
						</div>
					</div>
					<p>Review complete details of each seller's quotation.</p>

					<div className={`tab-content ${activeTab === "details" ? "active" : ""}`} id="details">
						<div className="vendor-detail-container">
							<table className="vendor-detail-layout">
								<thead>
									<tr>
										<th>S.No.</th>
										<th>Size</th>
										<th>Thickness</th>
										<th>Ends</th>
										<th>Finish</th>
										<th>Quantity</th>
										<th>Unit of Measure</th>
										{quotations.map((quote, index) => (
											<th key={index} colSpan={2}>{quote.vendor_name}</th>
										))}
									</tr>
									<tr>
										<td></td>
										<td></td>
										<td></td>
										<td></td>
										<td></td>
										<td></td>
										<td></td>
										{quotations.map((_, index) => (
											<>
												<th key={`rate-${index}`}>Rate</th>
												<th key={`value-${index}`}>Value</th>
											</>
										))}
									</tr>
								</thead>
								<tbody>
									{quotations[0].items.map((item, itemIndex) => (
										<tr key={`item-${itemIndex}`}>
											<td>{itemIndex + 1}</td>
											<td>{item.size || '-'}</td>
											<td>{item.wall_thickness || '-'}</td>
											<td>{item.end || '-'}</td>
											<td>{item.finish || '-'}</td>
											<td>{item.universal_qty || '-'}</td>
											<td>{item.quantity_unit || '-'}</td>
											{quotations.map((quote, quoteIndex) => {
												const currentItem = quote.items[itemIndex] || {};
												return (
													<>
														<td key={`rate-${quoteIndex}-${itemIndex}`}>
															{currentItem.unit_price ? Number(currentItem.unit_price).toFixed(2) : '-'}
														</td>
														<td key={`value-${quoteIndex}-${itemIndex}`}>
															{currentItem.unit_price && currentItem.universal_qty
																? (Number(currentItem.universal_qty) * Number(currentItem.unit_price)).toFixed(2)
																: '-'}
														</td>
													</>
												);
											})}
										</tr>
									))}
									<tr>
										<td colSpan={7}><strong>Basic Value</strong></td>
										{quotations.map((quote, index) => {
											const basicValue = quote.items.reduce((sum, item) => {
												return sum + (Number(item.universal_qty) * Number(item.unit_price));
											}, 0);
											return (
												<td key={`basic-${index}`} colSpan={2}>{basicValue.toFixed(2)}</td>
											);
										})}
									</tr>

									<tr>
										<td colSpan={7}><strong>Other Charges</strong></td>
										{quotations.map((quote, index) => (
											<td key={`other-${index}`} colSpan={2}>{Number(quote.other_charges || 0).toFixed(2)}</td>
										))}
									</tr>

									<tr>
										<td colSpan={7}><strong>Total Taxable Value</strong></td>
										{quotations.map((quote, index) => {
											const totalTax = Number(quote.subtotal || 0) + Number(quote.other_charges || 0);
											return <td key={`taxable-${index}`} colSpan={2}>{totalTax.toFixed(2)}</td>;
										})}
									</tr>

									<tr>
										<td colSpan={7}><strong>GST (18.00%) </strong></td>
										{quotations.map((quote, index) => (
											<td key={`gst-${index}`} colSpan={2}>
												{/* {Number(quote.gst_percentage || 0).toFixed(2)}%<br /> */}
												{Number(quote.gst_amount || 0).toFixed(2)}
											</td>
										))}
									</tr>

									<tr style={{ backgroundColor: "#eaf6ff" }}>
										<td colSpan={7}><strong>Grand Total</strong></td>
										{quotations.map((quote, index) => {
											const basicValue = quote.items.reduce((sum, item) => {
												return sum + (Number(item.universal_qty) * Number(item.unit_price));
											}, 0);
											const totalTaxable = basicValue + Number(quote.other_charges || 0);
											const gstAmount = totalTaxable * (Number(quote.gst_percentage || 0) / 100);
											const grandTotal = totalTaxable + gstAmount;
											return (
												<td key={`grand-${index}`} colSpan={2}>
													<strong>{grandTotal.toFixed(2)}</strong>
												</td>
											);
										})}
									</tr>

									<tr>
										<td colSpan={7}></td>
										{quotations.map((quote, index) => (
											<td key={`action-${index}`} colSpan={2}>
												{quote.status === 'Success' ? (
													<span className="accepted-status">Accepted</span>
												) : (
													<button
														className="btn btn-primary"
														onClick={() => handleSelectOffer(quote.vendor_name, quote.vendor_id)}
														disabled={isUpdatingStatus}
													>
														{isUpdatingStatus ? 'Processing...' : 'Accept'}
													</button>
												)}
											</td>
										))}
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>

				<div className={`tab-content ${activeTab === "market" ? "active" : ""}`} id="market">
					<div className="coming-soon-container">
						<h2>Market Analysis</h2>
						<div className="coming-soon-message">
							<p>This feature is coming soon!</p>
							<p>We're working hard to bring you comprehensive market analysis tools.</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default BuyerQuotationDashboard;